export const jobKey = (jobId: number | string) => `job:${jobId}`;
export const groupKey = (groupId: number | string) => `group:${groupId}`;
export const taskKey = (taskId: number | string) => `task:${taskId}`;
